import(/* webpackMode: "eager" */ "/data/web/bmg_001_toolbox/apps/web-front/src/app/login/page.tsx");
